import type { Event } from '../contracts/event.js';

export const mustRedact = (event: Event.Type, personId?: string): boolean => {
  const competition = event.competition ?? false;
  const admin =
    (personId && event.admin?.personIds?.includes(personId)) ?? false;
  const finished = (event.close ?? event.finish) < new Date();
  return competition && !admin && !finished;
};
